import React, { useState, useContext } from "react";
import { Button, Modal, Row, Col, Typography } from "antd";
import { Link } from "react-router-dom";
import {
  PlusOutlined,
  SolutionOutlined,
  ContainerOutlined,
} from "@ant-design/icons";
import { urls, USER_ROLES } from "../../../../utils";
import { UserContext } from "../../../../contexts/UserContext";

const { Text } = Typography;

export const BotaoAcao = () => {
  const { user } = useContext(UserContext);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const canCreate = user?.authorities?.includes(USER_ROLES.INCLUIR_DENUNCIA);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  if (!canCreate) {
    return null;
  }

  return (
    <>
      <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
        Novo Registro
      </Button>

      <Modal
        title="Criar novo registro"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        maskClosable={false}
      >
        <Text>Selecione o tipo de registro que você deseja criar:</Text>

        <Row gutter={16} style={{ marginTop: "24px" }}>
          <Col span={12}>
            <Link to={urls.ATENDIMENTO_CRIAR}>
              <Button
                type="primary"
                block
                icon={<SolutionOutlined />}
                onClick={handleCancel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Novo Atendimento
              </Button>
            </Link>
          </Col>
          <Col span={12}>
            <Link to={urls.DENUNCIA_CRIAR}>
              <Button
                block
                icon={<ContainerOutlined />}
                onClick={handleCancel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                Nova Denúncia
              </Button>
            </Link>
          </Col>
        </Row>
      </Modal>
    </>
  );
};
